import React, {useEffect, useState} from 'react';
import Cookies from "universal-cookie";
import {useNavigate} from "react-router-dom";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPhone} from "@fortawesome/free-solid-svg-icons";

import Agent from "../../Network/Agent";
import {KEY_TOKEN, projectUrl, supportPhone} from "../../Config/SharedConfig";
import ToolBar from "../../Components/Elements/ToolBar";
import InputPrimary from "../../Components/Elements/InputPrimary";
import ButtonPrimary from "../../Components/Elements/ButtonPrimary";
import {RouteEnumFinal} from "../../Config/RouteEnum";
import ButtonSecondary from "../../Components/Elements/ButtonSecondary";

const Login = () => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [buttonLoading, setButtonLoading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [errors, setErrors] = useState({ phoneNumber: null });

    const navigate = useNavigate()

    const submitPhone = async (e) => {
        e.preventDefault();
        if (phoneNumber.length !== 11) {
            setErrors({ phoneNumber: 'فرمت وارد شده اشتباه است' });
            setButtonLoading(false);
            return;
        }

        setButtonLoading(true);
        setIsDisabled(true);
        const cookies = new Cookies();

        try {
            const response = await Agent.Auth.loginByPhone(phoneNumber);
            const passport = response.data.result.passport;
            navigate(RouteEnumFinal.AUTH_LOGIN_VERIFY, {state:{passport: passport, phoneNumber: phoneNumber}})
        } catch (error) {
            console.log(error)
            setErrors({ phoneNumber: error.response.data.errors.at(0).message });
            setButtonLoading(false);
            setIsDisabled(false);
        }
    };

    useEffect(() => {
        const cookies = new Cookies();
        cookies.remove(KEY_TOKEN);
        cookies.remove(KEY_TOKEN, { path: '/' });
        cookies.remove(KEY_TOKEN, {
            path: '/',
            domain: `.${projectUrl}`,
        });
        cookies.remove(KEY_TOKEN, {
            path: '/',
            domain: `${projectUrl}`,
        });
    }, []);

    return (
        <>
            <ToolBar title={'ورود'} url={""} arrowDisplay={"d-none"} />

            <section className=''>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='mobile-subtitle-regular cl-subtitle mt-8'>
                                برای ورود به بخش مدیریت شماره موبایل خود را در وارد کنید :
                            </div>
                        </div>
                        <div className='col-12'>
                            <form id='form_send_phone' onSubmit={submitPhone}>
                                <div className='mt-32'>
                                    <InputPrimary
                                        dir="ltr"
                                        onChange={(e) => setPhoneNumber(e.target.value)}
                                        value={phoneNumber}
                                        inputClasses={errors.phoneNumber ? 'hasError' : ''}
                                        name='user_phone'
                                        id='user_phone'
                                        type='number'
                                        placeHolder='شماره تماس: 09123334444'/>
                                    <div className='mobile-body-1-regular cl-tomato mt-custom-4 mr-8'>
                                        {errors.phoneNumber || ''}
                                    </div>
                                </div>
                                <div className='mt-32'>
                                    <ButtonPrimary
                                        mode='dark-mode'
                                        text='ادامه'
                                        isLoading={buttonLoading}
                                        isDisabled={isDisabled}/>
                                </div>
                            </form>
                            <div className='mt-32'>
                                <ButtonSecondary
                                    mode='dark-mode'
                                    className="border-0"
                                    href={`tel:${supportPhone}`}
                                    isLoading={false}
                                    isDisabled={false}>
                                    <div className="d-flex align-items-center gap-2">
                                        تماس با پشتیبانی
                                        <FontAwesomeIcon icon={faPhone} />
                                    </div>
                                </ButtonSecondary>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Login;
